import { i18n } from "services/i18nService";

import { OBJECT_TYPES } from "appConstants";

const PRICE_TIER_IMPORT_OPTION = {
  id: OBJECT_TYPES.PRICE_TIER.fullString,
  name: i18n("objectType.pricetier.SentencePlural"),
};

export const COMPANION_IMPORT_OPTIONS = [
  {
    id: OBJECT_TYPES.ITEM.fullString,
    name: i18n("objectType.item.SentencePlural"),
  },
  {
    id: OBJECT_TYPES.CUSTOMER.fullString,
    name: i18n("objectType.customer.SentencePlural"),
  },
  {
    id: OBJECT_TYPES.VENDOR.fullString,
    name: i18n("objectType.vendor.SentencePlural"),
  },
  {
    id: OBJECT_TYPES.BOM.fullString,
    name: i18n("objectType.bom.SentencePlural"),
  },

  {
    id: OBJECT_TYPES.SALES_ORDER.fullString,
    name: i18n("objectType.salesorder.SentencePlural"),
  },
  {
    id: OBJECT_TYPES.SALES_RECEIPT.fullString,
    name: i18n("objectType.salesreceipt.SentencePlural"),
  },
];

export const IMPORT_OPTIONS = [
  ...COMPANION_IMPORT_OPTIONS,
  PRICE_TIER_IMPORT_OPTION,
];

export const EMPTY_RECORD = {
  objectType: null,
  location: null,
  date1: null,
  uploadFile: null,
  selectedWorksheet: null,
};
